import {DatePicker, Modal, TimePicker} from "antd";
import moment from "moment";
import React, {useEffect, useState} from "react";
import {useStore} from "../../../../hooks/useStore";

const CompleteTransferModal = ({isOpen, onClose, record, refetch}) => {
    const stores = useStore();
    const [groupData, setGroupData] = useState();

    const [cutOffEndDateTimeData, setCutOffEndDateTimeData] = useState({
        cutOffEndDate: "",
        cutOffEndHour: ""
    });
    const timeFormat = "HH:mm";

    const handleDateChange = (date, dateString) => {
        setCutOffEndDateTimeData(prevState => ({
            ...prevState,
            cutOffEndDate: dateString
        }));
    };

    const handleTimeChange = (time, timeString) => {
        setCutOffEndDateTimeData(prevState => ({
            ...prevState,
            cutOffEndHour: timeString
        }));
    };

    const handleCompleteTransfer = async () => {
        const result = await stores.transferStore.updateTransferGroupCutOff({
            transferGroupId: record._id,
            cutOffEndDate: cutOffEndDateTimeData.cutOffEndDate,
            cutOffEndHour: cutOffEndDateTimeData.cutOffEndHour
        });
        setGroupData(result);
        onClose();
        refetch();
    };

    useEffect(() => {
        if (record?.cutOffEndDate) {
            const date = moment(record.cutOffEndDate);
            setCutOffEndDateTimeData({
                cutOffEndDate: date.format("YYYY-MM-DD"),
                cutOffEndHour: date.format("HH:mm")
            });
        }
    }, [record]);

    return (
        <Modal
            visible={isOpen}
            onCancel={onClose}
            onOk={handleCompleteTransfer}
            okText="Kaydet"
            cancelText="Kapat"
        >
            <div>
                <h3>Cut Off Bitiş Tarihi</h3>
                <div style={{display: "flex", gap: 10}}>
                    <DatePicker
                        onChange={handleDateChange}
                        value={
                            cutOffEndDateTimeData.cutOffEndDate
                                ? moment(cutOffEndDateTimeData.cutOffEndDate)
                                : null
                        }
                    />
                    <TimePicker
                        format={timeFormat}
                        onChange={handleTimeChange}
                        value={
                            cutOffEndDateTimeData.cutOffEndHour
                                ? moment(cutOffEndDateTimeData.cutOffEndHour, timeFormat)
                                : null
                        }
                    />
                </div>
            </div>
        </Modal>
    );
};

export default CompleteTransferModal;
